__turbopack_context__.v({
  "cta": "TripCard-module__lbw4_G__cta",
  "dot-flashing": "TripCard-module__lbw4_G__dot-flashing",
  "dotFlashing": "TripCard-module__lbw4_G__dotFlashing",
  "footerRow": "TripCard-module__lbw4_G__footerRow",
  "gallerySlot": "TripCard-module__lbw4_G__gallerySlot",
  "loading": "TripCard-module__lbw4_G__loading",
  "locations": "TripCard-module__lbw4_G__locations",
  "markdown": "TripCard-module__lbw4_G__markdown",
  "price": "TripCard-module__lbw4_G__price",
  "priceFrom": "TripCard-module__lbw4_G__priceFrom",
  "priceLine": "TripCard-module__lbw4_G__priceLine",
  "priceNights": "TripCard-module__lbw4_G__priceNights",
  "priceNightsText": "TripCard-module__lbw4_G__priceNightsText",
  "tripCardContentInner": "TripCard-module__lbw4_G__tripCardContentInner",
});
